import React, { useState, useEffect } from "react";
import { doc, setDoc, getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase/firebaseConfig";
import Header from "../../components/Layout/Header.jsx";
import Footer from "../../components/Layout/Footer.jsx";

const getDefaultFormData = (nextIndex = "") => ({
  targetIndexValue: nextIndex,
  UITitle: "",
  description: "",
  price: "1.99",
  category: [],
  occasion: "",
  imageUrl: "/cardImages/",
  heroImage: "",
  videoDemo: "",
  detailImage1: "",
  detailImage2: "",
  customName: false,
  customVideo: false,
  isActive: true,
  qrX: 0,
  qrY: 0,
  qrW: 73,
  qrH: 72,
});

export default function AddProductAdmin() {
  const [presetCategories, setPresetCategories] = useState([
    "Milestone",
    "Holiday",
    "Celebration",
    "Sympathy",
  ]);

  const [presetOccasions, setPresetOccasions] = useState([
    "Birthday",
    "Christmas",
    "Graduation",
    "Wedding",
  ]);

  const [codeNameOptions, setCodeNameOptions] = useState([]);
  const [codeName, setCodeName] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [newOccasion, setNewOccasion] = useState("");
  const [formData, setFormData] = useState(getDefaultFormData());

  const refreshInventoryAndOptions = async () => {
    const snapshot = await getDocs(collection(db, "inventory"));
    const existingDocs = snapshot.docs.map((doc) => doc.data());

    const maxIndex = Math.max(
      0,
      ...existingDocs.map((doc) => doc.targetIndexValue || 0)
    );

    const nextIndex = maxIndex + 1;

    const publicFiles = await fetch("/php/getAvailableCardImages.php").then(
      (res) => res.json()
    );

    const usedNames = snapshot.docs.map((doc) => doc.id);
    const available = publicFiles.filter((name) => !usedNames.includes(name));

    setFormData(getDefaultFormData(nextIndex));
    setCodeNameOptions(available);
    setCodeName(available.length > 0 ? available[0] : "");
  };

  useEffect(() => {
    const loadOptions = async () => {
      try {
        await refreshInventoryAndOptions();
      } catch (err) {
        console.error("Failed to fetch options:", err);
      }
    };

    loadOptions();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const toggleCategory = (cat) => {
    setFormData((prev) => ({
      ...prev,
      category: prev.category.includes(cat)
        ? prev.category.filter((c) => c !== cat)
        : [...prev.category, cat],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!codeName) {
      alert("❌ Please select a Code Name before saving.");
      return;
    }

    const docId = codeName;

    const newItem = {
      ...formData,
      imageUrl: `/cardImages/${codeName}.jpg`,
      price: parseFloat(formData.price),
      targetIndexValue: parseInt(formData.targetIndexValue),
      qrX: parseInt(formData.qrX),
      qrY: parseInt(formData.qrY),
      qrW: parseInt(formData.qrW),
      qrH: parseInt(formData.qrH),
    };

    try {
      await setDoc(doc(db, "inventory", docId), newItem);

      alert(
        `✅ Product added: ${docId}\n\n🧠 Remember to update MindAR in Unity:\nhttps://hiukim.github.io/mind-ar-js-doc/tools/compile/`
      );

      setNewCategory("");
      setNewOccasion("");

      await refreshInventoryAndOptions();
    } catch (error) {
      console.error("Error adding product:", error);
      alert("❌ Failed to add product.");
    }
  };

  return (
    <>
      <Header />

      <div className="form-wrapper">
        <h2>Add New Product to Inventory</h2>

        <p>
          <strong>Generated Index ID:</strong> {formData.targetIndexValue}
        </p>

        <p>
          <strong>Code Name:</strong>{" "}
          <select value={codeName} onChange={(e) => setCodeName(e.target.value)}>
            {codeNameOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
          <span title="Auto-generated based on .jpg files in /cardImages and not yet added to inventory.">
            {" "}
            ℹ️
          </span>
        </p>

        {codeName && (
          <div className="image-preview">
            <p>
              <strong>Preview:</strong>
            </p>
            <img
              src={`/cardImages/${codeName}.jpg`}
              alt={`Preview of ${codeName}`}
            />
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {[
            ["UITitle", "Customer-Facing Title"],
            ["price", "Price"],
            ["heroImage", "Hero Image"],
            ["videoDemo", "Video Demo"],
            ["detailImage1", "Detail Image 1"],
            ["detailImage2", "Detail Image 2"],
          ].map(([field, label]) => (
            <div key={field}>
              <label>{label}:</label>
              <input
                type="text"
                name={field}
                value={formData[field]}
                onChange={handleChange}
                required={["UITitle", "price"].includes(field)}
              />
            </div>
          ))}

          <div>
            <label>QR X (px):</label>
            <input
              type="number"
              name="qrX"
              value={formData.qrX}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>QR Y (px):</label>
            <input
              type="number"
              name="qrY"
              value={formData.qrY}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>QR Width (px):</label>
            <input
              type="number"
              name="qrW"
              value={formData.qrW}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>QR Height (px):</label>
            <input
              type="number"
              name="qrH"
              value={formData.qrH}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>Description:</label>
            <br />
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows={4}
              required
            />
          </div>

          <div>
            <label>Categories:</label>
            <br />

            {presetCategories.map((cat) => (
              <label key={cat}>
                <input
                  type="checkbox"
                  checked={formData.category.includes(cat)}
                  onChange={() => toggleCategory(cat)}
                />{" "}
                {cat}
              </label>
            ))}

            <input
              type="text"
              placeholder="Add new category"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
              onBlur={() => {
                if (newCategory && !presetCategories.includes(newCategory)) {
                  setPresetCategories((prev) => [...prev, newCategory]);
                  setFormData((prev) => ({
                    ...prev,
                    category: [...prev.category, newCategory],
                  }));
                  setNewCategory("");
                }
              }}
            />
          </div>

          <div>
            <label>Occasion:</label>
            <br />

            {presetOccasions.map((opt) => (
              <label key={opt}>
                <input
                  type="radio"
                  name="occasion"
                  value={opt}
                  checked={formData.occasion === opt}
                  onChange={handleChange}
                />{" "}
                {opt}
              </label>
            ))}

            <input
              type="text"
              placeholder="Add new occasion"
              value={newOccasion}
              onChange={(e) => setNewOccasion(e.target.value)}
              onBlur={() => {
                if (newOccasion && !presetOccasions.includes(newOccasion)) {
                  setPresetOccasions((prev) => [...prev, newOccasion]);
                  setFormData((prev) => ({
                    ...prev,
                    occasion: newOccasion,
                  }));
                  setNewOccasion("");
                }
              }}
            />
          </div>

          {[
            ["customName", "Custom Name"],
            ["customVideo", "Custom Video"],
            ["isActive", "Is Active"],
          ].map(([name, label]) => (
            <label key={name}>
              <input
                type="checkbox"
                name={name}
                checked={formData[name]}
                onChange={handleChange}
              />{" "}
              {label}
            </label>
          ))}

          <br />
          <br />

          <button type="submit">Save Product</button>
        </form>
      </div>

      <Footer />
    </>
  );
}